import _ from 'lodash'
import api from '../api'
// import i18n from '../locale'
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import conf from "../config/url";
import getLanguageData from './locale'


Vue.use(VueI18n);
// 自动根据浏览器系统语言设置语言
const navLang = navigator.language
// localStorage.setItem('current_language',navLang)


const zhLogin = require('./language').default.zhLogin
const enLogin = require('./language').default.enLogin
const frLogin = require('./language').default.frLogin
// let language = window.localStorage.current_language || navLang
// 调用模块化配置接口
// async function getConfiguration() {
//   await api.configuration
//     .getConfiguration(conf.confUrl)
//     .then(async(res) => {
//       let frontendConfig = res.data.frontendConfig
//       frontendConfig.map(item=>{
//         if(item.key == 'is_i18n'){
//         	localStorage.setItem('is_i18n', item.value)
//         }
//       })
//       getLanguageData()
//
//     })
// }
localStorage.setItem('is_i18n', 'false')
// getConfiguration()


// getLanguageData()
// let zhObj = {}
// let enObj = {}
// zhObj = JSON.parse(localStorage.getItem(`language_zh-CN_data`)) ? JSON.parse(localStorage.getItem(`language_zh-CN_data`)) : {}
// enObj = JSON.parse(localStorage.getItem(`language_en-US_data`)) ? JSON.parse(localStorage.getItem(`language_en-US_data`)) : {}
// // const message = {
//   'zh-CN':zhObj,
//   'en-US':enObj
// }
const message = {
    'zh-CN':zhLogin,
    'zh-cn':zhLogin,
    'en-US':enLogin,
    'fr-FR':frLogin
}
console.log('messa,',message)
export default new VueI18n({
    locale: 'zh-CN',
    messages: message,
    silentTranslationWarn: true,
});
